import config from '../config.json'

import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Color from "@arcgis/core/Color";
import Graphic from "@arcgis/core/Graphic";
import Circle from "@arcgis/core/geometry/Circle";
import Point from "@arcgis/core/geometry/Point";
import FeatureEffect from "@arcgis/core/layers/support/FeatureEffect";
import FeatureFilter from "@arcgis/core/layers/support/FeatureFilter";

import { EstadosWidgets, ActionEstadosWidgetsInvertirValor, ActionListaResumenCercaCambiarListaResumen, ActionEstadosWidgetsCambiarValor } from './reducerClasses';
import { getFeatureLayers, getListaResumenBase, removeGraphicsMapViewSegunListaResumen } from './../utils/mapaUtils';
import { getListaOfListaResumenCapa } from '../utils/mapaUtils';
import { EstadosWidgetCerca, CodigosControllers, CodigosListaListaResumenNoCargada, TiposListaResumen } from './../utils/enums';
import { createButton } from '../configvisores/domElements';

export class CustomExpand {
    constructor(widget, collapseIconClass, funcionCambiarLabels, funcionSetStateNull = null){
        const { expandIconClass, expandTooltip, persistencia, labelsCambiar } = widget.propiedadesAdicionales;
        this.widget = widget;
        this.widgetActivo = persistencia ? widget.visible : false;
        this.collapseIconClass = collapseIconClass;
        [this.container, this.containerIcono] = createButton(widget.visible ? collapseIconClass : expandIconClass, expandTooltip)

        this.container.addEventListener("click", () => {
            if (widget.visible){
                widget.visible = false;
                if (persistencia){
                    this.widgetActivo = false;
                }
                this.containerIcono.classList.remove(collapseIconClass);
                this.containerIcono.classList.add(expandIconClass);
            } else {
                if (funcionSetStateNull){
                    funcionSetStateNull(null);
                }
                widget.visible = true;
                if (labelsCambiar){
                    //labelsCambiar se puede definir solamente para widgets de ESRI
                    if (widget.viewModel.state === "ready"){
                        funcionCambiarLabels(labelsCambiar, widget.container);
                    } else {
                        widget.viewModel.watch("state", state => {
                            if (state === "ready"){
                                funcionCambiarLabels(labelsCambiar, widget.container);
                            }
                        });
                    }
                }
                if (persistencia){
                    this.widgetActivo = true;
                }
                this.containerIcono.classList.remove(expandIconClass);
                this.containerIcono.classList.add(collapseIconClass);
            }
        });
    }
}

export class CustomWidget {
    constructor(view, htmlContainer, visible, propiedadesAdicionales){
        this.view = view;
        this.container = htmlContainer;
        this.propiedadesAdicionales = propiedadesAdicionales;
        this._visible = visible;
        this._custom = true;
        htmlContainer.style.display = visible ? "block" : "none";
    }
    get custom(){
        return this._custom;
    }
    get visible(){
        return this._visible;
    }
    set visible(visible){
        this._visible = visible;
        this.container.style.display = visible ? "block" : "none";
    }
}

export class CustomWidgetCerca extends CustomWidget{
    constructor(dispatchEstadosWidgets, dispatchListaResumenCerca, parametros, ...args){
        super(...args);
        this.dispatchEstadosWidgets = dispatchEstadosWidgets;
        this.dispatchListaResumenCerca = dispatchListaResumenCerca;
        const { colorRelleno, colorBorde, opacidadRelleno, anchoBorde, tamanoPunto, colorPunto } = config.parametrosCodigos.cerca;        
        this.estilos = { 
            colorRelleno: parametros[colorRelleno],
            colorBorde: parametros[colorBorde],
            opacidadRelleno: parametros[opacidadRelleno],
            anchoBorde: parametros[anchoBorde],
            tamanoPunto: parametros[tamanoPunto],
            colorPunto: parametros[colorPunto],
        }
        const colorRellenoObj = new Color(this.estilos.colorRelleno);
        colorRellenoObj.a = this.estilos.opacidadRelleno;
        this.symbolCircle = {
            type: "simple-fill",
            style: "solid",
            color: colorRellenoObj,
            outline: { width: this.estilos.anchoBorde, color: this.estilos.colorBorde}
        }
        this.animationCircleAumentando = false;
        this._estado = EstadosWidgetCerca.created;
        this.graphicsLayer = new GraphicsLayer({
            listMode: "hide"
        });
        this.view.map.add(this.graphicsLayer);
        this.graphicCircleActual = null;
        this._radioActual = 100;
        this._idLayerSeleccionado = null;
        this._layerSeleccionado = null;
        this.numRegistrosActual = null;
    }
    #quitarEfectoLayerSeleccionado(){
        if (this._layerSeleccionado){
            this._layerSeleccionado.featureEffect = null;
            this.dispatchEstadosWidgets(new ActionEstadosWidgetsCambiarValor(EstadosWidgets.propIdLayerClearEnFiltro, this._idLayerSeleccionado));
        }
    }
    #getQueryOfCircle(){
        const query = this._layerSeleccionado.createQuery();
        query.outSpatialReference = this.view.map.basemap.spatialReference;
        query.geometry = this.graphicCircleActual.geometry;
        return query;
    }
    #animateCircle(){
        return setInterval(() => {
            const factor = this.animationCircleAumentando ? this.graphicCircleActual.symbol.color.a + 0.01 : this.graphicCircleActual.symbol.color.a - 0.01;
            let nuevaOpacidad = (factor).toFixed(2);
            if (nuevaOpacidad <= 0){
                nuevaOpacidad = 0;
                this.animationCircleAumentando = true;
            }
            if (nuevaOpacidad >= this.symbolCircle.color.a){
                nuevaOpacidad = this.symbolCircle.color.a;
                this.animationCircleAumentando = false;
            }
            this.graphicCircleActual.symbol = {...this.symbolCircle, color: {...this.symbolCircle.color, a: nuevaOpacidad} };
        }, (20));
    }
    get visible(){
        return super.visible;
    }
    set visible(visible){
        super.visible = visible;
        if (!visible && ([EstadosWidgetCerca.drawing, EstadosWidgetCerca.drawRunning, EstadosWidgetCerca.drawn].includes(this._estado))){
            this.estado = EstadosWidgetCerca.created;
        }
    }
    get radioActual(){
        return this._radioActual;
    }
    set radioActual(radio){
        this._radioActual = radio;
        if (this._estado === EstadosWidgetCerca.drawn){
            const { longitude, latitude } = this.graphicCircleActual.geometry.center;
            this.crearCirculo(longitude, latitude);
            this.estado = EstadosWidgetCerca.drawRunning;
        }
    }
    get idLayerSeleccionado(){
        return this._idLayerSeleccionado;
    }
    set idLayerSeleccionado(id){
        if (this._estado !== EstadosWidgetCerca.created && this._estado !== EstadosWidgetCerca.drawing){
            this.#quitarEfectoLayerSeleccionado();
        }
        this._idLayerSeleccionado = id;
        this._layerSeleccionado = getFeatureLayers(this.view.map).find(x => x.id === this._idLayerSeleccionado)
        if (this._estado === EstadosWidgetCerca.drawn){
            this.estado = EstadosWidgetCerca.drawRunning;
        }
    }
    get estado(){
        return this._estado;
    }
    set estado(estado){
        this._estado = estado;
        if (estado === EstadosWidgetCerca.created || estado === EstadosWidgetCerca.createdSinQuitarEfecto){
            removeGraphicsMapViewSegunListaResumen(this.view, TiposListaResumen.cerca);
            if (estado === EstadosWidgetCerca.createdSinQuitarEfecto){
                this._estado = EstadosWidgetCerca.created;
            } else {
                this.#quitarEfectoLayerSeleccionado();
            }
            this.graphicsLayer.removeAll();
            this.view.popup.autoOpenEnabled = true;
            this.view.container.style.cursor = "auto";
        } else if (estado === EstadosWidgetCerca.drawing){
            this.#quitarEfectoLayerSeleccionado();
            this.view.popup.autoOpenEnabled = false;
            this.view.container.style.cursor = "crosshair";
        } else if (estado === EstadosWidgetCerca.drawRunning){
            this.view.container.style.cursor = "not-allowed";
            const query = this.#getQueryOfCircle();
            const intervalId = this.#animateCircle();
            this._layerSeleccionado.queryFeatureCount(query).then(count => {
                clearInterval(intervalId);
                if (this._visible){
                    this.numRegistrosActual = count;
                    if (!this._layerSeleccionado.featureReduction){
                        this._layerSeleccionado.featureEffect = new FeatureEffect({
                            filter: new FeatureFilter({
                                geometry: this.graphicCircleActual.geometry
                            }),
                            includedEffect: config.includedEffectWidgetCerca,
                            excludedEffect: "opacity(35%)"
                        })
                    }
                    this.estado = EstadosWidgetCerca.drawn;
                } else {
                    //Si el usuario cierra el widget durante la ejecución:
                    this.estado = EstadosWidgetCerca.created;
                }
            });
        } else if (estado === EstadosWidgetCerca.drawn){
            this.view.container.style.cursor = "crosshair";
        } else if (estado === EstadosWidgetCerca.running){
            this.view.container.style.cursor = "auto";
            this.view.popup.autoOpenEnabled = true;

            const intervalId = this.#animateCircle();
            
            const listaResumen = getListaResumenBase(this._layerSeleccionado);
            if (listaResumen){
                getListaOfListaResumenCapa(this.#getQueryOfCircle(), listaResumen, this._layerSeleccionado, CodigosControllers.widgetCerca).then(lista => {
                    clearInterval(intervalId);
                    listaResumen.lista = lista;
                    this.dispatchListaResumenCerca(new ActionListaResumenCercaCambiarListaResumen(null)); //Si no se hace esto, quedan los registros de anteriores consultas
                    this.dispatchListaResumenCerca(new ActionListaResumenCercaCambiarListaResumen(listaResumen ?? CodigosListaListaResumenNoCargada.errorAlCargar));
                    this.graphicCircleActual.symbol = this.symbolCircle; 
                    this.estado = EstadosWidgetCerca.executed;
                })
            }
        } else if (estado === EstadosWidgetCerca.executed){

        }
        this.dispatchEstadosWidgets(new ActionEstadosWidgetsInvertirValor(EstadosWidgets.propCercaCambio));
    }
    crearCirculo(longitude, latitude){
        this.graphicsLayer.removeAll();
        const punto = new Point({ longitude: longitude, latitude: latitude, spatialReference: this.view.map.basemap.spatialReference });
        const graphicCircle = new Graphic({
            geometry: new Circle({ center: punto, radius: this.radioActual, radiusUnit: "kilometers", numberOfPoints: 200 }),
            symbol: this.symbolCircle
        });
        this.graphicsLayer.add(graphicCircle);
        this.graphicCircleActual = graphicCircle;
        this.graphicsLayer.add(new Graphic({
            geometry: punto,
            symbol: {
                type: "simple-marker",
                style: "circle",
                size: this.estilos.tamanoPunto,
                color: this.estilos.colorPunto,
                outline: { width: 0 }
            }
        }));
    }
}